export const TRANS_COOKIE = 'etandbgetrans';
export const PATH_COOKIE = 'etandbgepath';
export const LANDING_VIDEO_ALREADY_PLAYED_COOKIE = 'etandbgevideo';
export const LOGGED_IN_BEFORE = 'etandbgeloggedin';